(function index(global) {
  'use strict';

  if (!global.NewHomeSource.GalleryOnPage.PlanTracking.Index) {
    return;
  }

  const rootElement = document.querySelector('[data-component="gallery-on-page"]');
  if (!rootElement) {
    return;
  }

  const planTracking = new global.NewHomeSource.GalleryOnPage.PlanTracking.Index();
  planTracking
    .setGalleryElement(rootElement)
    .create();
}(window));
